module.exports = __webpack_public_path__ + "img/keynote.85bb2473.svg";